import { TabView, TabViewProps } from "primereact/tabview";
import React from "react";

/**
 * A PrimeReact `TabView` whose children may include `false` / `null` for a tab that is not shown
 * (CLE-2965: the SuperAdmin-only "AI Insights v2" tab).
 *
 * `TabView` walks its children with `React.Children.map`, which keeps a `false` child in place and
 * counts it — so a hidden tab would still take an index, shifting every tab after it (header ids,
 * `aria-controls`, the active index). `React.Children.toArray` drops it instead, so the tabs that
 * are shown are numbered exactly as they would be had the hidden one never been written.
 */
export function ConditionalTabView({ children, ...props }: TabViewProps) {
  return <TabView {...props}>{React.Children.toArray(children)}</TabView>;
}

export default ConditionalTabView;
